module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_A.50231137.jpg";